module.exports = __webpack_public_path__ + "media/images/profile_logo/logo_empty_end-fec8859b4667c0d20ab2cb9867a8315a.png";